export default __webpack_public_path__ + "static/media/figuremap6.2b8134f7.png";